module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebarContent"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('div', {
    staticClass: "certificates"
  }, [_c('a', {
    staticClass: "fancybox",
    attrs: {
      "href": require('../../../static/photos/certificates/clippers.jpg'),
      "rel": "certificates",
      "title": "Certifikát střihové úpravy pudla"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/photos/certificates/thumb_clippers.jpg"),
      "width": "240"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "fancybox",
    attrs: {
      "href": require('../../../static/photos/certificates/massage.jpg'),
      "rel": "certificates",
      "title": "Certifikát masáže psů"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/photos/certificates/thumb_massage.jpg"),
      "width": "240"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxTitle"
  }, [_c('h2', [_vm._v("Novinky")])]), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('p', {
    staticClass: "notFound"
  }, [_vm._v("V této rubrice nejsou žádné články.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxTitle"
  }, [_c('h2', [_vm._v("Kontakt")])]), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("Lenka Holubová")]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("\n            Pražského 662 (vchod z boku domu)"), _c('br'), _vm._v("\n            Praha 5 - Hlubočepy (Barrandov)\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "phone"
  }, [_vm._v("+420 723 222 400")]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:holubova@salonjaja.cz"
    }
  }, [_c('span', {
    attrs: {
      "id": "rbcContactEmail"
    }
  }, [_vm._v("holubova@salonjaja.cz")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxTitle"
  }, [_c('h2', [_vm._v("Certifikáty")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c829f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragments/AppSidebar.vue
// module id = 73
// module chunks = 0